import { createAction } from 'redux-actions-helpers'
import { LessonType } from './types'
import { ModuleType } from '../ModulePage/types'
import { ProgressType } from '../CoursePage/types'

export const fetchModuleLessonPage = createAction(
  '@@lesson-page/FETCH_MODULE_LESSON_PAGE',
  (id: string, moduleId: string, lessonId: string): any => ({
    id,
    moduleId,
    lessonId,
  })
)

export const fetchModuleLessonPageSuccess = createAction(
  '@@lesson-page/FETCH_MODULE_LESSON_PAGE_SUCCESS',
  (result: LessonType): any => ({ result })
)

export const fetchModuleLessonPageFailure = createAction(
  '@@lesson-page/FETCH_MODULE_LESSON_PAGE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourseUserState = createAction(
  '@@lesson-page/FETCH_COURSE_USER_STATE',
  (id: string): any => ({ id })
)

export const fetchCourseUserStateSuccess = createAction(
  '@@lesson-page/FETCH_COURSE_USER_STATE_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchCourseUserStateFailure = createAction(
  '@@lesson-page/FETCH_COURSE_USER_STATE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchSimpleTaskStatus = createAction(
  '@@lesson-page/FETCH_SIMPLE_TASK_STATUS',
  (
    courseId: string,
    moduleId: string,
    lessonId: string,
    simpleTaskId: string
  ): any => ({
    courseId,
    moduleId,
    lessonId,
    simpleTaskId,
  })
)

export const fetchSimpleTaskStatusSuccess = createAction(
  '@@lesson-page/FETCH_SIMPLE_TASK_STATUS_SUCCESS',
  (result: ProgressType): any => ({ result })
)

export const fetchSimpleTaskStatusFailure = createAction(
  '@@lesson-page/FETCH_SIMPLE_TASK_STATUS_FAILURE',
  (error: string): any => ({ error })
)

export const joinSimpleTask = createAction(
  '@@lesson-page/JOIN_SIMPLE_TASK',
  (
    simpleTaskId: string,
    courseId: string,
    moduleId: string,
    lessonId: string
  ): any => ({
    simpleTaskId,
    courseId,
    moduleId,
    lessonId,
  })
)

export const joinSimpleTaskSuccess = createAction(
  '@@lesson-page/JOIN_SIMPLE_TASK_SUCCESS'
)

export const joinSimpleTaskFailure = createAction(
  '@@lesson-page/JOIN_SIMPLE_TASK_FAILURE',
  (error: string): any => ({ error })
)

export const sendSimpleTask = createAction(
  '@@lesson-page/SEND_SIMPLE_TASK',
  (
    courseId: string,
    moduleId: string,
    lessonId: string,
    simpleTaskId: string,
    field_value?: string,
    file?: File
  ): any => ({
    courseId,
    moduleId,
    lessonId,
    simpleTaskId,
    field_value,
    file,
  })
)

export const sendSimpleTaskSuccess = createAction(
  '@@lesson-page/SEND_SIMPLE_TASK_SUCCESS'
)

export const sendSimpleTaskFailure = createAction(
  '@@lesson-page/SEND_SIMPLE_TASK_FAILURE',
  (error: string): any => ({ error })
)

export const setLessonComplete = createAction(
  '@@lesson-page/SET_LESSON_COMPLETE',
  (id: string, moduleId: string, lessonId: string): any => ({
    id,
    moduleId,
    lessonId,
  })
)

export const setLessonCompleteSuccess = createAction(
  '@@lesson-page/SET_LESSON_COMPLETE_SUCCESS'
)

export const setLessonCompleteFailure = createAction(
  '@@lesson-page/SET_LESSON_COMPLETE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModule = createAction(
  '@@lesson-page/FETCH_MODULE',
  (id: string, moduleId: string): any => ({
    id,
    moduleId,
  })
)

export const fetchModuleSuccess = createAction(
  '@@lesson-page/FETCH_MODULE_SUCCESS',
  (result: ModuleType): any => ({ result })
)

export const fetchModuleFailure = createAction(
  '@@lesson-page/FETCH_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@lesson-page/DESTROY')
